import { ApiClientDashboardDto } from "../api/clientDashboard";
import { ClientDashboardDto } from "../app/clientDashboard";
import { mapFromApiGigSummary } from "./gig";

export const mapFromApiClientDashboard = (apiDto: ApiClientDashboardDto): ClientDashboardDto => ({
    ...apiDto,
    ongoingGigs: apiDto.ongoingGigs.map(mapFromApiGigSummary)
});